import React, { useEffect, useState } from 'react';

import Button from '@mui/material/Button';
import { useSelector, useDispatch } from 'react-redux';
import { faShareAlt } from '@fortawesome/free-solid-svg-icons';

import { config } from 'handimap-react-lib/config';
import { setAlert } from 'handimap-react-lib/store/actions/alertActions';
import { FontAwesomeSvgIcon } from 'handimap-react-lib/components/FontAwesomeSvgIcon';
import { useTranslation } from 'react-i18next';
import { useResponsive } from 'handimap-react-lib/hooks/useResponsive';

export const ShareButton = ({styles}) => {
  const origin = [...useSelector(state => state.directions.origin.marker)];
  const destination = [...useSelector(state => state.directions.destination.marker)];
  
  const profil = useSelector(state => state.profils.profil);
  const condition = useSelector(state => state.profils.condition);
  const multimodal = useSelector(state => state.profils.multimodal);
  const selectedDate = useSelector(state => state.profils.time);
  
  const selectedPath = useSelector(state => state.directions.selectedPath);

  const dispatch = useDispatch();
  const {t} = useTranslation();
  const { isMobile } = useResponsive();

  const [urlTocopy, setUrlToCopy] = useState('');

  const handleCopy = () => {
    navigator.clipboard.writeText(encodeURI(urlTocopy));
    dispatch(setAlert(t('share-itinerary.message'), 'success', t('share-itinerary.message-title'), 'status'));
  };

  useEffect(() => {
    setUrlToCopy(`${config.url.PUBLIC_URL}?origin=${origin[0]},${origin[1]}&destination=${destination[0]},${destination[1]}&profil=${profil}&condition=${condition}&multimodal=${multimodal}&selectedPath=${selectedPath}&time=${selectedDate.format('YYYY-MM-DDTHH:mm')}`);
  }, [origin, destination, profil, condition, multimodal, selectedPath, selectedDate]);

  return (
    <Button 
      sx={styles}
      variant='text' 
      size={isMobile ? 'small' : 'large'}
      endIcon={<FontAwesomeSvgIcon icon={faShareAlt} />}
      onClick={handleCopy}
    >
      {t('share-itinerary.button')}
    </Button>
  );
};